import React, { useMemo, useCallback, useState } from 'react';
import { Layout as AntLayout, Menu, Dropdown, Button, Spin } from 'antd';
import { Avatar } from 'antd';
import { UserOutlined, DownOutlined, LeftOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { LogoDarkIcon } from 'icons';
import styles from './style.module.scss';
import AuthService from '../../../services/Auth';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'hooks/useNavigate';
import { useTranslation } from 'react-i18next';
import { useNavigate as useNavigate_ } from 'react-router-dom';

import UIHelper from 'helpers/UIHelper';
import ChangePasswordModal from 'components/changePasswordModalView';

import useUser from 'hooks/useUser';
import { useFilter } from '../../../hooks/useFilter';

const hideHeadersBtnLinks = ['/boarddocs/new'];
export const nativeBackRoutes = ['finance', 'invoices'];

const { Header: AntHeader } = AntLayout;

const Header = ({ fullWidth }) => {
  const navigate = useNavigate();
  const nativeNavigate = useNavigate_();
  const { pathname, ...rest } = useLocation();
  const { handleClearFilters } = useFilter();
  const { t } = useTranslation();
  const {
    user: userInfo,
    changeCurrentUserPassword,
    changePasswordErrors,
    setChangePasswordErrors,
    changePasswordIsOpen,
    setChangePasswordIsOpen,
    logut,
  } = useUser();

  const [dropdownMenuVisible, setDropdownMenuVisible] = useState(false);

  const onClickMenu = useCallback(
    (value) => {
      if (value.key === 'logout') {
        handleClearFilters();
        AuthService.logout();
        logut();
        navigate('/login');
      }
    },
    [navigate],
  );

  const handleBackRedirect = useCallback(
    (skipLength) => {
      const needNativeBack = pathname
        .split('/')
        .filter(Boolean)
        .find((i) => nativeBackRoutes.includes(i));
      return () =>
        needNativeBack
          ? nativeNavigate(-1)
          : navigate(UIHelper.getListRoute(pathname, skipLength));
    },
    [pathname, navigate, nativeNavigate],
  );

  const toggleChangePasswordModal = useCallback(() => {
    setDropdownMenuVisible(false);
    setChangePasswordIsOpen((state) => !state);
  }, []);

  const toggleDropdown = useCallback((flag) => {
    setDropdownMenuVisible(flag);
  }, []);

  const menu = useMemo(() => {
    return (
      <Menu onClick={onClickMenu}>
        <Menu.Item key='0'>
          <span onClick={toggleChangePasswordModal}>Cambia password</span>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='logout'>Logout</Menu.Item>
      </Menu>
    );
  }, [onClickMenu, toggleChangePasswordModal]);

  const backArrowBtn = useMemo(() => {
    let skipLengthIndex = [/(new|\d+?!edit)/i, /edit/i].findIndex(
      (regex) => regex && regex.test(pathname),
    );

    if (pathname.includes('/view') && !pathname.includes('edit/view')) {
      return null;
    }
    if (hideHeadersBtnLinks.includes(pathname)) {
      return null;
    }

    if (skipLengthIndex === -1) {
      skipLengthIndex = [/\d+/i].findIndex(
        (regex) => regex && regex.test(pathname),
      );
    }
    if (pathname.includes('answers') || pathname.includes('list_company')) {
      skipLengthIndex = 1;
    }

    if (
      pathname.includes('interviews/interviews/answers') &&
      pathname.includes('new')
    ) {
      skipLengthIndex = 2;
    }

    if (pathname.includes('edit/view')) {
      skipLengthIndex = 2;
    }

    return skipLengthIndex !== -1 ? (
      <Button
        type='primary-white'
        icon={<LeftOutlined />}
        onClick={handleBackRedirect(skipLengthIndex + 1)}
        // onClick={() => nativeNavigate(-1)}
      >
        {t('Torna indietro')}
      </Button>
    ) : null;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, navigate, nativeNavigate]);

  return (
    <AntHeader
      fixed='true'
      className={classNames(styles.header, {
        [styles.header_full]: fullWidth,
      })}
    >
      {fullWidth && (
        <div className={styles.logo}>
          <LogoDarkIcon height={'49px'} width={'auto'} />
        </div>
      )}
      <div className={styles.leftSide}>{backArrowBtn}</div>
      <div className={styles.rightSide}>
        <Avatar
          style={{ backgroundColor: '#002637' }}
          icon={<UserOutlined />}
        />
        {userInfo?.user ? (
          <Dropdown
            overlay={menu}
            trigger={['click']}
            onVisibleChange={toggleDropdown}
            visible={dropdownMenuVisible}
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a className={styles.userName} onClick={(e) => e.preventDefault()}>
              {userInfo.user.name} {userInfo.user.surname} <DownOutlined />
            </a>
          </Dropdown>
        ) : (
          <Spin size={'small'} />
        )}
      </div>
      {changePasswordIsOpen && (
        <ChangePasswordModal
          setChangePasswordErrors={setChangePasswordErrors}
          loading={userInfo.loading}
          onClickChangePassword={changeCurrentUserPassword}
          onCancel={toggleChangePasswordModal}
          changePasswordErrors={changePasswordErrors}
        />
      )}
    </AntHeader>
  );
};

export default Header;
